import { Grid } from '@simplywallst/ui-core';

import { Settings } from './Settings';
import { CreateWatchlist } from './CreateWatchlist';

import type { Watchlist } from '@/hooks/useWatchlist';

import { WatchlistDropdown } from '../WatchlistDropdown';

import { useSelectedWatchlist } from '../../hooks/useSelectedWatchlist';

import { Background } from './styled';

interface Props {
  watchlist: Watchlist;
}

export const Header = ({ watchlist }: Props) => {
  const [, selectWatchlist] = useSelectedWatchlist();
  return (
    <Background>
      <Grid
        templateColumns="minmax(100px, max-content) max-content"
        justifyContent="space-between"
        paddingTop="x2"
        paddingTopLg="x1"
        paddingBottom="x2"
        paddingBottomLg="x0"
        paddingX="x2"
        paddingXLg="x0"
      >
        <WatchlistDropdown
          watchlistId={watchlist?.id || null}
          onSelect={selectWatchlist}
        />
        <Grid templateColumns="auto auto" gap="8px">
          <CreateWatchlist />
          {watchlist && <Settings watchlist={watchlist} />}
        </Grid>
      </Grid>
    </Background>
  );
};
